import React, { useState } from "react";
import { filterOptions, _checkValue, getImageUploadEditValue } from '../../helpers/form';
import { Form, Input, Select, DatePicker, InputNumber, Space, Button, Switch, Upload, Tooltip, Checkbox, Radio, Popover } from "antd";
import { PlusOutlined, DeleteOutlined, UploadOutlined, InfoCircleOutlined, MessageOutlined } from '@ant-design/icons';
import i18next from "i18next";
import _ from 'lodash';
import 'moment/locale/fr';
import localeEn from 'antd/es/date-picker/locale/en_US';
import localeFr from 'antd/es/date-picker/locale/fr_FR';
import dot from 'dot-object';
import ReactHtmlParser from 'react-html-parser';

import { PhoneInputAnt } from "../Inputs";
import Geolocation from './components/geolocation';
import { deepFind } from "../../helpers/deepFind";
import AjaxSelect from './components/ajaxSelect';
import AjaxModal from './components/ajaxModal';
import Tag from "./components/tag";
import LinkingModal from './components/linkingModal';
import Website from "../Inputs/Website";
import { countries } from "countries-list";
import GroupInput from "./components/groupInput";
import { numberWithCommas } from "../DynamicViewNew/helper";
import SupplyChainMap from './components/supplyChainMap';
import { getToken } from 'datastake-daf/src/helpers/Token';
import { getPopupContainer } from "../../helpers/popUp";
import dayjs from "dayjs";
import { getMainApiUrl, getAppHeader } from "../../services/BaseService";

export const propHasValue = (val) => {
  if (Array.isArray(val)) {
    return val.length > 0 ? true : false;
  }
  return typeof val !== 'undefined' && val !== null;
};

export const checkCondition = (condition, repeatValues, formsValue) => {
  let [field, match, wantedValue] = condition.split(/( is | includes | not | notEmpty | notOnly )/gmi);
  const isRepeatable = field.split('./').length > 1;
  const isNotEmpty = match === 'notEmpty';
  const formValue = isRepeatable ? repeatValues : formsValue;
  field = isRepeatable ? field.split('./')[1] : field;
  const value = deepFind(formValue, field);
  const isShown = _checkValue(
    isNotEmpty ? field : wantedValue,
    match,
    isNotEmpty ? formValue : value
  );
  return isShown;
}
export function showHideInput(input, formsValue, repeatIndex, repeatValues, setValues, ref) {
  if (input.showIf) {
    const isOrCond = input.showIf.indexOf('OR') >= 0;
    const allParts = input.showIf.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
    const parts = allParts.map(condition => {
      let [field, match, wantedValue] = condition.split(/( is | includes | not | notEmpty | notOnly )/gmi);
      match = match ? match.trim() : null;
      const isRepeatable = field.split('./').length > 1;
      const isNotEmpty = match === 'notEmpty';
      const formValue = isRepeatable ? repeatValues : formsValue;
      field = isRepeatable ? field.split('./')[1] : field;
      if (match && field.split('.').length > 1) {
        if (input.inputs) {
          const value = deepFind(formValue, field);
          const isShown = _checkValue(
            isNotEmpty ? field : wantedValue,
            match,
            isNotEmpty ? formValue : value
          );
          return isShown;
        } else {
          if ((isRepeatable ? !repeatValues : !formsValue)) {
            return false;
          } else {
            const value = deepFind(formValue, field);
            const isShown = _checkValue(
              isNotEmpty ? field : wantedValue,
              match,
              isNotEmpty ? formValue : value
            );
            return isShown;
          }
        }
      } else {
        const value = deepFind(formValue, field);
        const isShown = _checkValue(
          isNotEmpty ? field : wantedValue,
          match,
          isNotEmpty ? formValue : value
        );
        return isShown;
      }
    });
    const isShown = parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
    if (!isShown && propHasValue(dot.pick(ref, formsValue)) && input.deleteDataOnHide !== false) {
      dot.delete(ref, formsValue);
    }
    return isShown;
  }
  return true;
}

export function getInputData(name, input, value, commentValue, path, values) {
  const props = {
    placeholder: input.labelHint ? input.labelHint : getInputLabel(input.label, values, true),
    valueplaceholder: input.valueLabel || null,
    disabled: input.disabled || false,
    accept: input.accept || undefined,
  }

  if (input.inputType === 'total100' && !value) {
    value = [{
      type: null,
      value: null
    }];
  } else if (['date', 'year'].includes(input.inputType)) {
    value = value ? dayjs(value) : undefined;
  } else if (input.inputType === 'switch') {
    if (!propHasValue(value)) {
      value = value || false;
      if (typeof path === 'string') {
        dot.str(path, value, values);
      }
    }
  }

  const config = {
    name,
    call: input.call,
    automaticallyLink: input.automaticallyLink,
    props,
    formsValue: values,
    onNewSetValue: input.onNewSetValue,
    multiple: input.multiple,
    updateOptions: input.updateOptions || false,
    options: input.options,
    optionsFilter: input.optionsFilter,
    filterCond: input.filterCond,
    disableOtherFields: input.disableOtherFields,
    updateOtherFields: input.updateOtherFields,
    repeatLabel: input.repeatLabel,
    unique: input.unique,
    totalMax: input.totalMax,
    modalTitle: input.modalTitle,
    buttonText: input.buttonText,
    stakeholderId: input.stakeholderId,
    value,
    commentValue,
    commentHint: input.commentHint ? input.commentHint : i18next.t('Please specify'),
    rules: (input.rules || []).map(r => {
      if (r.message && r.message.indexOf('errors::') >= 0) {
        r.message = i18next.t(r.message);
      }
      return r;
    }),
  }
  if (input.inputType === 'switch' && input.autocomplete) {
    Object.assign(config, { autocomplete: input.autocomplete });
  }
  if (input.inputType === 'switch') {
    if (input.replace) {
      Object.assign(config, { replace: input.replace });
    }
    if (input.unique) {
      Object.assign(config, { unique: input.unique });
    }
  }
  if (input.inputType === 'linkingModal') {
    Object.assign(config, {
      content: input.inputs
    });
  }

  return config;
}
export function getInputHeadLines(type, i, input, values) {
  switch (type) {
    case 'h2':
      return <h2 className={`title-semibold-2 ${input.marginBottom || ''} ${input.groupHeader || ''} ${i ? (input.marginTop || '') : ''}`}>
        <span>{getInputLabel(input, values)}</span>
      </h2>
    case 'h3':
      return <h3 className={`title-semibold-3 ${input.marginBottom || ''} ${input.groupHeader || ''} ${i ? (input.marginTop || '') : ''}`}>
        <span>{getInputLabel(input, values)}</span>
      </h3>
    case 'h4':
      return <h4 className={`title-semibold-4 ${input.marginBottom || ''} ${input.groupHeader || ''} ${i ? (input.marginTop || '') : ''}`}>
        <span>{getInputLabel(input, values)}</span>
      </h4>
    case 'h5':
      return <h5 className={`title-semibold-5 ${input.marginBottom || ''} ${input.groupHeader || ''} ${i ? (input.marginTop || '') : ''}`}>
        <span>{getInputLabel(input, values)}</span>
      </h5>
    case 'h6':
      return <h6 className={`title-semibold-6 ${input.marginBottom || ''} ${input.groupHeader || ''} ${i ? (input.marginTop || '') : ''}`}>
        <span>{getInputLabel(input, values)}</span>
      </h6>
    default:
      return null;
  }
}
export function getInputLabel(input, formsValue = {}, asText = false) {
  if (typeof input.label === 'object') {
    const validations = Object.keys(input.label);
    const key = validations.find(v => {
      let [path, match, wantedValue] = v.split(/( is | includes | not | notEmpty )/gmi);
      const value = dot.pick(path, formsValue);
      return _checkValue(wantedValue, match, value)
    });
    const label = key ? input.label[key] : input.label[validations[0]];
    if (input.tooltip) {
      return (
        <>
          {ReactHtmlParser(label)}
          <Popover content={input.tooltip} placement="top">
            <InfoCircleOutlined className="ml-1 icon-mt" />
          </Popover>
        </>
      )
    }
    return input.description && !asText ? (
      <>
        {ReactHtmlParser(label)}
        <Tooltip title={input.description} placement="top">
          <InfoCircleOutlined className="ml-1 icon-mt" />
        </Tooltip>
      </>
    ) : ReactHtmlParser(label)
  } else {
    if (input.tooltip && !asText) {
      return (
        <>
          {(ReactHtmlParser(input.label))}
          <Popover content={input.tooltip} placement="top">
            <InfoCircleOutlined className="ml-1 icon-mt" />
          </Popover>
        </>
      )
    }
    return input.description && !asText ? (
      <>
        {(ReactHtmlParser(input.label))}
        <Tooltip title={input.description} placement="top">
          <InfoCircleOutlined className="ml-1 icon-mt" />
        </Tooltip>
      </>
    ) : ReactHtmlParser(input.label)
  }
}
export function getSelectOptions(option, formsValue = {}) {
  if (typeof option.label === 'object') {
    const validations = Object.keys(option.label);
    const key = validations.find(v => {
      let [path, match, wantedValue] = v.split(/( is | includes | not | notEmpty )/gmi);
      const value = dot.pick(path, formsValue);
      return _checkValue(wantedValue, match, value)
    });
    option.label = key ? option.label[key] : option.label[validations[0]];
  }
  return option;
}
export function getSectionLabel(labels, values) {
  if (typeof labels === 'object') {
    const validations = Object.keys(labels);
    const key = validations.find(v => {
      let [path, match, wantedValue] = v.split(/( is | includes | not | notEmpty )/gmi);
      const value = dot.pick(path, values);
      return _checkValue(wantedValue, match, value)
    });
    return key ? labels[key] : labels[validations[0]];
  }
  return labels;
}
export function getSubtitles(subtitles, position, formsValue = {}, repeatIndex, repeatValues) {
  let subtitle = subtitles && subtitles[position];
  if (subtitle && typeof subtitle === 'object') {
    let newSubtitle = subtitle.default || '';
    const subKeys = Object.keys(subtitle).filter(k => k !== 'default');
    let ind = 0;
    while (subKeys.length > ind) {
      const subKey = subKeys[ind];
      let [field, match, wantedValue] = subKey.split(/( is | includes | not | notEmpty )/gmi);
      match = match ? match.trim() : null;
      const isRepeatable = field.split('./').length > 1;
      const isNotEmpty = match === 'notEmpty';
      const formValue = isRepeatable ? repeatValues : formsValue;
      field = isRepeatable ? field.split('./')[1] : field;
      if (match && field.split('.').length > 1) {
        const value = deepFind(formValue, field);
        const isValid = _checkValue(
          isNotEmpty ? field : wantedValue,
          match,
          isNotEmpty ? formValue : value
        );
        if (isValid) {
          newSubtitle = subtitle[subKey];
          ind = subKeys.length;
        }
      } else {
        const value = deepFind(formValue, field);
        const isValid = _checkValue(
          isNotEmpty ? field : wantedValue,
          match,
          isNotEmpty ? formValue : value
        );
        if (isValid) {
          newSubtitle = subtitle[subKey];
          ind = subKeys.length;
        }
      }
      ind += 1;
    }
    subtitle = newSubtitle;
  }
  return subtitle
    ? <h5 className="title-semibold-5" style={{ margin: '0px 0px 10px 0px' }}>
      {subtitle}
    </h5> : null
}
export function getFormTitles(titles, key, position) {
  let tilte = titles && titles[key];
  return tilte
    ? <h3 className={`title-semibold-3 mb0 ${position ? 'mt-3' : ''}`}>
      {tilte}
    </h3> : null
}
export const filterSelectOptions = (inputValue, option) => {
  const stringOption = option.children ? (
    option.children.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
  ) : (
    option.label ? (
      option.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
    ) : ''
  );
  inputValue = inputValue.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  return stringOption.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
}
export const checkForValueInOptions = (value, options) => {
  const option = options.find(o => o.value === value);
  if (option) {
    return value;
  }
  return undefined;
}
export const updateFormValues = (repeatIndex, repeatValues, inputName, value, formsValue, name, mainForm) => {
  formsValue = Object.assign(formsValue, {
    ...mainForm.getFieldsValue(true)
  });
  if (typeof repeatIndex === 'number' && repeatValues) {
    if (!repeatValues[inputName] || !_.isEqual(repeatValues[inputName], value)) {
      repeatValues[inputName] = value;
      if (!formsValue[name]) {
        formsValue[name] = [];
      }
      formsValue[name][repeatIndex] = repeatValues;
      mainForm.setFieldsValue({ [name]: formsValue[name] });
      mainForm.scrollToField([name, repeatIndex, inputName]);
    }
  } else {
    if (repeatValues && inputName !== name) {
      if (!repeatValues[inputName] || !_.isEqual(repeatValues[inputName], value)) {
        repeatValues[inputName] = value;
        formsValue[name] = repeatValues;
        mainForm.setFieldsValue({ [name]: formsValue[name] });
        mainForm.scrollToField([name, inputName]);
      }
    } else {
      if (!formsValue[name] || !_.isEqual(formsValue[name], value)) {
        mainForm.setFieldsValue({ [name]: value });
        mainForm.scrollToField(name);
      }
    }
  }
}
export const inputOnBlur = [];

export const inputTypeComponent = {
  text: ({ props, rules }) => {
    const maxRule = rules.find(r => r.max);
    const maxProps = {};
    if (maxRule) {
      maxProps.maxLength = maxRule.max;
    }
    return <Input size="medium" {...maxProps} allowClear autoComplete="new-password" type="text" {...props} placeholder={i18next.t('Type')} />
  },
  number: ({ props, rules }) => {
    const maxRule = rules.find(r => r.max);
    if (maxRule) {
      return <InputNumber allowClear autoComplete="new-password" {...props} type="number" min={0} max={maxRule.max} placeholder={i18next.t('Type number')} />
    }
    return <InputNumber
      allowClear
      autoComplete="new-password"
      {...props}
      placeholder={i18next.t('Type number')}
      min={0}
      formatter={value => numberWithCommas(value)}
      parser={value => value.replace(/\$\s?|(,*)/g, '')}
    />
  },
  select: ({ value, options, optionGroup, props, formsValue, optionsFilter, filterCond, repeatValues, repeatIndex, name, inputName, address, addressData }, { forms, allForms, form, setAddress }) => {
    let opts;
    if (typeof options === 'string') {
      const [formName, key] = options.split('.');
      const values = formsValue[formName];
      if (values && Array.isArray(values)) {
        if (forms[formName]) {
          opts = values.map(val => val[key]).filter(v => propHasValue(v)).map(v => {
            const iOptions = forms[formName].inputs[key].options || [];
            const iOption = iOptions.find(opt => opt.value === v);
            return {
              label: iOption ? iOption.label : v,
              value: iOption ? iOption.label : v,
            };
          });
        }
      } else if (values && values[key]) {
        opts = [
          {
            label: values[key],
            value: values[key],
          }
        ]
      } else {
        opts = [];
      }
    } else {
      opts = options.filter(o => !o.onlyView);
    }
    opts = JSON.parse(JSON.stringify(opts));
    opts = opts.map(o => getSelectOptions(o, formsValue));
    if (optionsFilter && Array.isArray(optionsFilter)) {
      opts = filterOptions(opts, optionsFilter, formsValue, repeatValues, filterCond)
    }
    if (propHasValue(value)) {
      const selectOption = opts.find(o => o.value === value);
      if (!selectOption) {
        value = undefined;
        updateFormValues(repeatIndex, repeatValues, inputName, value, formsValue, name, form)
      }
    }
    if (optionGroup && Array.isArray(optionGroup) && optionGroup.length) {
      const gKeys = [];
      const groupOptions = optionGroup.map(o => {
        if (!gKeys.includes(o.value)) {
          gKeys.push(o.value);
        }
        return {
          label: o.label,
          items: opts.filter(op => op.group === o.value),
        }
      });
      const notGrouped = opts.filter(op => !gKeys.includes(op.group));
      if (notGrouped.length) {
        groupOptions.unshift(...notGrouped);
      }
      opts = groupOptions;
    }
    return <Select autoComplete="new-password"
      allowClear
      {...getPopupContainer()}
      showSearch
      filterOption={filterSelectOptions}
      optionFilterProp="children"
      {...props}
      placeholder={i18next.t('Select one option')}
      onChange={(val, selectedValue) => {
        if (address && selectedValue) {
          dot.str(address, selectedValue.children, addressData);
          setAddress({
            ...addressData
          })
        }
        if (props.onChange) {
          props.onChange(val);
        }
      }}
    >
      {(opts || []).map((option, i) => option.items ?
        <Select.OptGroup label={option.label}>
          {option.items.map((og, j) =>
            <Select.Option value={og.value} key={`${i}${j}`}>
              {og.label}
            </Select.Option>
          )}
        </Select.OptGroup> :
        <Select.Option value={option.value} key={i}>
          {option.label}
        </Select.Option>
      )}
    </Select>
  },
  multiselect: ({ value, options, optionGroup, optionsFilter, filterCond, props, formsValue, repeatValues, repeatIndex, inputName, name, tags }, { forms, form }) => {
    let opts;
    if (typeof options === 'string') {
      const [formName, key] = options.split('.');
      const values = formsValue[formName];
      if (values && Array.isArray(values)) {
        opts = values.map(val => val[key]).filter(v => propHasValue(v)).map(v => {
          const iOptions = forms[formName].inputs[key].options || [];
          const iOption = iOptions.find(opt => opt.value === v);
          return {
            label: iOption ? iOption.label : v,
            value: iOption ? iOption.label : v,
          };
        });
      } else if (values && values[key]) {
        opts = [
          {
            label: values[key],
            value: values[key],
          }
        ]
      } else {
        opts = [];
      }
    } else {
      opts = options;
    }
    opts = JSON.parse(JSON.stringify(opts));
    opts = opts.map(o => getSelectOptions(o, formsValue));
    if (optionsFilter && Array.isArray(optionsFilter)) {
      opts = filterOptions(opts, optionsFilter, formsValue, repeatValues, filterCond)
    }
    if (propHasValue(value) && Array.isArray(value) && value.length > 0 && !tags) {
      try {
        const values = opts.filter(o => value.includes(o.value));
        if (propHasValue(values) && Array.isArray(values) && !(values.length === value.length && value.every((v) => values.includes(v)))) {
          updateFormValues(repeatIndex, repeatValues, inputName, values.map(o => o.value), formsValue, name, form)
        }
      } catch {
      }
    }
    if (optionGroup && Array.isArray(optionGroup) && optionGroup.length) {
      const gKeys = [];
      const groupOptions = optionGroup.map(o => {
        if (!gKeys.includes(o.value)) {
          gKeys.push(o.value);
        }
        return {
          label: o.label,
          items: opts.filter(op => op.group === o.value),
        }
      });
      const notGrouped = opts.filter(op => !gKeys.includes(op.group));
      if (notGrouped.length) {
        groupOptions.unshift(...notGrouped);
      }
      opts = groupOptions;
    }

    return <Select
      allowClear
      {...getPopupContainer()}
      autoComplete="new-password"
      mode={tags ? "tags" : "multiple"}
      optionFilterProp="children"
      {...(tags ? { tokenSeparators: [',', '\n', '\t'] } : {})}
      filterOption={filterSelectOptions}
      {...props}
      placeholder={i18next.t('Select all relevant options')}>
      {(opts || []).map((option, i) => option.items ?
        <Select.OptGroup label={option.label}>
          {option.items.map((og, j) =>
            <Select.Option value={og.value} key={`${i}${j}`}>
              {og.label}
            </Select.Option>
          )}
        </Select.OptGroup> :
        <Select.Option value={option.value} key={i}>
          {option.label}
        </Select.Option>
      )}
    </Select>
  },
  date: ({ props, rules, repeatValues, formsValue }) => {
    const lng = localStorage.getItem('datastakeLng') || 'en';
    const maxRule = rules.find(r => r.max);
    if (maxRule) {
      let checkForMax = true;
      if (maxRule.condition) {
        checkForMax = checkCondition(maxRule.condition, repeatValues, formsValue)
      }
      if (checkForMax) {
        return <DatePicker
          allowClear
          autoComplete="new-password"
          {...props}
          placeholder={i18next.t('Select date')}
          format="DD MMM YYYY"
          locale={lng === 'fr' ? localeFr : localeEn}
          disabledDate={(current) => {
            return current && current >= dayjs().endOf('day');
          }}

        />
      }
    }
    return <DatePicker allowClear autoComplete="new-password" {...props} placeholder={i18next.t('Select date')} format="DD MMM YYYY" locale={lng === 'fr' ? localeFr : localeEn} />
  },
  comment: ({ props: { placeholder, ...props }, commentHint }) => {
    return <Input.TextArea allowClear maxLength={1000} placeholder={commentHint ? commentHint : placeholder} autoComplete="new-password" autoSize={{ minRows: 2, maxRows: 6 }} {...props} />
  },
  textarea: ({ props, rules }) => {
    const maxRule = rules.find(r => r.max);
    let maxLength = 1000;
    if (maxRule) {
      maxLength = maxRule.max;
    }
    return <Input.TextArea allowClear autoComplete="new-password" maxLength={maxLength} autoSize={{ minRows: 2, maxRows: 6 }} {...props} placeholder={i18next.t('Type')} />
  },
  phoneNumber: ({ name, inputName, props, value, repeatIndex, repeatValues, formsValue, country }, { form, setFormValues }) => {
    return <PhoneInputAnt allowClear={true} country={country ? deepFind(formsValue, country) : null} initialValue={value} {...props} onChange={val => {
      if (repeatValues) {
        const inputValues = Array.isArray(formsValue[name]) ? (formsValue[name] || []) : [];
        if (!inputValues[repeatIndex]) {
          inputValues[repeatIndex] = {}
        }
        inputValues[repeatIndex][inputName] = val;
        // form.setFieldsValue({ [name]: inputValues });
        formsValue[name] = inputValues;
        setFormValues(formsValue);
      } else {
        // form.setFieldsValue({ [name]: val });
        formsValue[name] = val;
        setFormValues(formsValue);
      }
      return val;
    }} />
  },
  switch: ({ props, value, restricted, autocomplete, formsValue, repeatIndex, name, inputName, replace }, { form, setFormValues, add, remove }) => {
    return <Switch
      {...props}
      defaultChecked={value || false}
      checked={value || false}
      onChange={(isChecked) => {
        if (autocomplete) {
          Object.keys(autocomplete).forEach(fKey => {
            if (Object.keys(formsValue).includes(fKey)) {
              if (Array.isArray(formsValue[fKey])) {
                formsValue[fKey][0] = isChecked ? autocomplete[fKey] : undefined;
              } else {
                formsValue[fKey] = isChecked ? autocomplete[fKey] : undefined;
              }
            } else {
              form.setFieldsValue({ [fKey]: isChecked ? autocomplete[fKey] : undefined });
            }
          });
        }
        if (propHasValue(repeatIndex) && restricted) {
          if (formsValue[name].length > 1) {
            form.setFieldsValue({
              [name]: formsValue[name].map((input, i) => {
                if (i === repeatIndex) {
                  input[inputName] = value;
                } else {
                  input[inputName] = undefined;
                }
                return input;
              }),
            });
          }
        }
        if (replace) {
          const [replaceTo, replaceWith] = replace.split('|');
          const newId = dot.pick(replaceWith, formsValue[name][repeatIndex]);
          dot.copy(replaceWith, replaceTo, formsValue[name][repeatIndex], formsValue);
          const [form, inpt] = replaceTo.split('.');
          formsValue[form][inpt] = newId;
          setFormValues(formsValue);
        }
      }} />
  },
  total100: ({ props, name, options, value }, { form }) => {
    value = value ? (Array.isArray(value) ? value : [value]) : []
    function totalValue() {
      let total = 0;
      (value || []).forEach(v => {
        total += v.value || 0;
      });
      return total;
    }
    function siblingTotal(type) {
      const siblingValues = value
        .filter(v => v.type !== type)
        .map(v => v.value)
      if (!siblingValues.length) {
        return 0;
      }
      if (siblingValues.length === 1) {
        return siblingValues[0];
      } else {
        return siblingValues.reduce((a, b) => a + b);
      }
    }

    return <div className="total100">
      <Form.List key={name} name={name}>
        {(fields, { add, remove }) => {
          if (fields.length === 0) {
            const formData = value || [];
            if (formData.length) {
              formData.forEach(f => {
                add(f);
              })
            } else {
              add({ type: null, value: null })
            }
          }
          return <React.Fragment>
            {fields.map((field, i) => {
              const v = value[field.name];
              return <Space className="total" key={i}>
                <Form.Item
                  noStyle
                  {...field}
                  name={[field.name, 'type']}
                  fieldKey={[field.fieldKey, 'type']}
                  initialValue={v.type}>
                  <Select
                    allowClear
                    showSearch
                    {...getPopupContainer()}
                    filterOption={filterSelectOptions}
                    optionFilterProp="children"
                    {...props}
                    placeholder={i18next.t('Select one option')}
                  >
                    {options.map((option, i) =>
                      <Select.Option value={option.value} key={i}>
                        {option.label}
                      </Select.Option>
                    )}
                  </Select>
                </Form.Item>
                <Form.Item
                  noStyle
                  {...field}
                  name={[field.name, 'value']}
                  fieldKey={[field.fieldKey, 'value']}
                  initialValue={v.value}>
                  <InputNumber
                    allowClear
                    name="value"
                    formatter={value => {
                      return value ? `${value}%` : '';
                    }}
                    disabled={!v.type}
                    placeholder={i18next.t('Type number')}
                    min={1}
                    max={100 - siblingTotal(v.type)}
                  />
                </Form.Item>

                {(fields.length - 1) === i ? <Button disabled={!v.value || !v.type || totalValue() >= 100} type="primary" icon={<PlusOutlined />} onClick={() => {
                  if ((value.map(v => v.value).reduce((a, c) => a + c) < 100) && value[i].type) {
                    add({ type: null, value: null })
                  }
                }} /> : null}
                {i < (fields.length - 1) ? <Button type="danger" icon={<DeleteOutlined />} onClick={() => {
                  remove(field.name);
                  if (fields.length === 1) {
                    add({});
                  }
                }} /> : null}

              </Space>
            }
            )}
          </React.Fragment>

        }}
      </Form.List>
      {(totalValue() > 100) ? <span className="error">The total fields value must be 100%</span> : null}
    </div>

  },
  percentage: ({ name, inputName, totalMax, repeatIndex, props, formsValue }) => {
    const isRepeatable = Array.isArray(formsValue[name]);
    let totalSiblings = 0;
    if (isRepeatable) {
      totalSiblings = (formsValue[name] || [])
        .filter((g, idx) => idx !== repeatIndex)
        .reduce((totl, grp) => {
          totl = totl + (grp[inputName] || 0);
          return totl;
        }, 0);
    }
    return <InputNumber
      allowClear
      {...props}
      placeholder={i18next.t('Type number')}
      min={0}
      max={totalMax ? (isRepeatable ? (100 - totalSiblings) : 100) : 100}
      formatter={value => {
        return value ? `${value}%` : '';
      }}
      parser={value => value.replace('%', '')}
      addonAfter="%"
    />
  },
  year: ({ props }) => {
    const lng = localStorage.getItem('datastakeLng') || 'en';
    return <DatePicker
      allowClear
      locale={lng === 'fr' ? localeFr : localeEn}
      picker="year"
      {...props}
      format="YYYY" />
  },
  upload: ({ props, rules, value, name, inputName, repeatIndex, repeatValues, formsValue }, { form, setFormValues }) => {
    const apiURL = getMainApiUrl();
    const accept = rules.length ? (rules.find(rule => Object.keys(rule).includes('accept')).accept || '*') : null;
    const values = (
      Array.isArray(value) ? value :
        (
          value &&
            typeof value === 'object' &&
            value.fileList &&
            Array.isArray(value.fileList) ?
            value.fileList.map(f => f.response).filter(f => f) : []
        )
    ) || [];

    const maxRule = rules.find(r => r.max);
    const maxProps = {};
    if (maxRule) {
      maxProps.maxCount = maxRule.max;
      if (maxRule.max > 1) {
        maxProps.multiple = true;
      }
    }
    return <Upload
      {...maxProps}
      accept={accept}
      action={`${apiURL}/upload`}
      headers={{
        Authorization: `Bearer ${getToken()}`,
        ...getAppHeader(),
      }}
      defaultFileList={values}>
      <Button icon={<UploadOutlined />} block>{i18next.t('Upload')}</Button>
    </Upload>
  },
  imageUpload: ({ props, rules, value, name, inputName, repeatIndex, repeatValues, formsValue }, { form, setFromValues, ...others }) => {
    const apiURL = getMainApiUrl();
    const values = getImageUploadEditValue(value)
    const maxRule = rules.find(r => r.max);
    const maxProps = {};
    if (maxRule) {
      maxProps.maxCount = maxRule.max;
      if (maxRule.max > 1) {
        maxProps.multiple = true;
      }
    }
    return <Upload
      {...maxProps}
      accept="image/*"
      classList={!values || !values.length ? 'empty' : ''}
      listType="picture-card"
      action={`${apiURL}/upload`}
      headers={{
        Authorization: `Bearer ${getToken()}`,
        ...getAppHeader(),
      }}
      defaultFileList={values}>
      <div style={{ width: '100%' }}>
        <PlusOutlined />
        <div>{i18next.t('Upload')}</div>
      </div>
    </Upload>
  },
  geolocation: ({ value, name, inputName, repeatIndex, repeatValues, formsValue, addressData }, { form }) => {
    let search = formsValue.country;
    if (addressData && addressData.address && Object.keys(addressData.address).length > 0) {
      if (addressData.address.country) {
        search = addressData.address.country;
      }
      if (addressData.address.level1) {
        search = `${addressData.address.level1}, ${addressData.address.country}`;
      }
      if (addressData.address.level2) {
        search = `${addressData.address.level2}, ${addressData.address.level1}, ${addressData.address.country}`;
      }
    } else {
      const country = countries[formsValue.country] || {};
      if (country) {
        search = country.name;
      }
      if (formsValue.administrativeLevel1Name) {
        search = `${search} ${formsValue.administrativeLevel1Name}`
      }
      if (formsValue.administrativeLevel2Name) {
        search = `${search} ${formsValue.administrativeLevel2Name}`
      }
    }
    return <Geolocation allowClear={true} name={name} val={value || {}} searchValue={search} />
  },
  ajaxSelect: ({
    call,
    automaticallyLink,
    name,
    inputName,
    props,
    formsValue,
    onNewSetValue,
    multiple,
    updateOptions,
    repeatValues,
    repeatIndex,
    updateOtherFields,
    disableOtherFields,
    value,
    unique,
    address,
    addressData = {}
  }, { form, forms, setAddress }) => {
    return <AjaxSelect
      allowClear={true}
      call={call}
      automaticallyLink={automaticallyLink}
      name={name}
      unique={unique}
      inputName={inputName}
      value={value}
      props={props}
      formsValue={formsValue}
      mainForm={form}
      repeatIndex={repeatIndex}
      repeatValues={repeatValues}
      onNewSetValue={onNewSetValue}
      multiple={multiple}
      updateOptions={updateOptions}
      onOptions={(options) => {
        if (propHasValue(repeatIndex)) {
          forms[name].inputs[inputName].options = options
        } else {
          forms[name].options = options
        }
      }}
      onChange={(ev, data) => {
        if (propHasValue(ev)) {
          const selectedValue = data.find(v => v.value === ev);
          if (address && selectedValue) {
            dot.str(address, selectedValue.label, addressData);
            setAddress({
              ...addressData
            })
          }
        }
      }}
      addressData
      setAddress
      address
    />
  },
  tag: ({ value, name, repeatLabel, inputName, repeatIndex, repeatValues, formsValue }, { form, setFormValues }) => {
    return <Tag allowClear={true} value={value || []} newPlaceholder={repeatLabel} />
  },
  linkingModal: ({ content }, { form, forms }) => {
    return <LinkingModal content={content} />
  },
  modal: ({
    call,
    automaticallyLink,
    name,
    inputName,
    props,
    formsValue,
    onNewSetValue,
    repeatValues,
    repeatIndex,
    value,
    modalTitle,
    buttonText,
  }, { form, setFormValues }) => {
    return <AjaxModal
      allowClear={true}
      call={call}
      automaticallyLink={automaticallyLink}
      name={name}
      inputName={inputName}
      value={value}
      props={props}
      formsValue={formsValue}
      mainForm={form}
      repeatIndex={repeatIndex}
      repeatValues={repeatValues}
      onNewSetValue={onNewSetValue}
      modalTitle={modalTitle}
      buttonText={modalTitle}
      onChange={(ev) => {
      }} />
  },
  website: ({ name, inputName, props, value, repeatIndex, repeatValues, formsValue }, { form }) => {
    return <Website allowClear={true} initialValue={value} {...props} onChange={val =>
      updateFormValues(repeatIndex, repeatValues, inputName, val, formsValue, name, form)
    } />
  },
  internallink: ({ name, inputName, props, value, repeatIndex, repeatValues, formsValue }, { form }) => {
    return <Website allowClear={true} initialValue={value} {...props} onChange={val =>
      updateFormValues(repeatIndex, repeatValues, inputName, val, formsValue, name, form)
    } />
  },
  group: ({ props, name, groupInputs }, { form }) => {
    return <GroupInput groupInputs={groupInputs}  {...props} />
  },
  radioGroup: ({ props, value, options, restricted, autocomplete, formsValue, repeatIndex, name, inputName, replace }, { form, setFormValues, add, remove }) => {
    return (
      <Radio.Group value={value} {...props}>
        {(options || []).map(o => {
          return <Radio key={o.value} value={o.value}>
            <div className="radio-title">
              {o.label}
            </div>
            {o.description ? <div className="radio-description">
              {o.description}
            </div> : null}

          </Radio>
        })}
      </Radio.Group>
    );
  },
  checkboxGroup: ({ props, value, options, restricted, autocomplete, formsValue, repeatIndex, name, inputName, replace }, { form, setFormValues, add, remove }) => {
    return (
      <Checkbox.Group value={value} {...props}>
        {(options || []).map(o => {
          return <Checkbox key={o.value} value={o.value}>
            <span className="radio-title">
              {o.label}
            </span>
            {o.description ? <span className="radio-description">
              {o.description}
            </span> : null}

          </Checkbox>
        })}
      </Checkbox.Group>
    );
  },
  supplyChainMap: ({ props, value, repeatValues, stakeholderId, formsValue }) => {
    const dataId = stakeholderId
      ? (repeatValues ? repeatValues[stakeholderId] : formsValue[stakeholderId])
      : undefined;
    return <SupplyChainMap
      key={dataId}
      value={value}
      selectable={true}
      dataId={dataId} />;
  },
}


export const GetFormItem = ({
  inputData,
  inputId,
  input,
  values,
  MainForm,
  options,
  plainForms,
  setValues,
  setAddress,
  i,
  onValuesChange = () => { },
}) => {
  const [isShown, setIsShown] = useState(!!inputData.commentValue);

  switch (input.inputType) {
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
    case 'h6':
      return getInputHeadLines(input.inputType, i, input, values);
    default:
      const rules = inputData.rules
        ? inputData.rules.filter(rule => !Object.keys(rule).includes('accept') && !Object.keys(rule).includes('max')) : [];

      const requiredRule = rules.find((r) => r.required);

      if (requiredRule && input.inputType === 'text') {
        rules.push({ whitespace: true, message: requiredRule.message || '' });
      }

      return <>
        <Form.Item
          {...(['total100', 'group'].includes(input.inputType) ? {} : {
            name: inputId,
            fieldKey: inputId,
            initialValue: inputData.value,
          })}
          {...(['upload', 'imageUpload'].includes(input.inputType) ? {
            valuePropName: "fileList",
            getValueFromEvent: (e) => {
              if (Array.isArray(e)) {
                return e;
              }
              return e && e.fileList && e.fileList.map(f => {
                if (f.response) {
                  return f.response;
                }
                return f;
              })
            }
          } : {})}
          style={input.showOnView === false ? { display: 'none' } : {}}
          {...(['switch'].includes(input.inputType) ? {
            labelCol: { span: 20 },
            style: {
              ...(input.showOnView === false ? { display: 'none' } : {}),
              flexDirection: 'row',
              justifyContent: 'space-between',
            }
          } : {})}
          className={input.comment ? `with-comment i-${input.inputType}` : `i-${input.inputType}`}
          data-id={inputData.name}
          rules={rules}
          required={
            inputData.rules && inputData.rules instanceof Array &&
              inputData.rules.filter(r => r.required).length > 0 ? true : false
          }
          label={getInputLabel(input, values)}
          extra={input.comment ? (<Button disabled={inputData.props.disabled} type="link" onClick={() => {
            setValues({
              ...values,
              [`${inputData.name}Comment`]: !inputData.commentValue ? '' : undefined,
            })
          }}>
            <Button
              type="link"
              disabled={inputData.props.disabled}
              icon={<MessageOutlined />}
              {...(!isShown
                ? {}
                : { danger: true })
              }
              onClick={() => {
                if (isShown) {
                  onValuesChange({}, { ...values, [`${inputData.name}Comment`]: null });
                }
                setIsShown((prev) => !prev);
                setValues({
                  ...values,
                  [`${inputData.name}Comment`]: typeof inputData.commentValue !== 'string'
                    ? '' : null,
                })
                if (typeof inputData.commentValue === 'string') {
                  MainForm.setFields([
                    {
                      name: `${inputData.name}Comment`,
                      value: null,
                    }
                  ]);
                }
              }}>
              {i18next.t(!isShown ? 'Add Comment' : 'Remove Comment')}
            </Button>
          </Button>) : null}>
          {inputTypeComponent[input.inputType]
            ? inputTypeComponent[input.inputType](inputData, {
              form: MainForm,
              forms: options,
              allForms: plainForms,
              setFormValues: setValues,
              setAddress
            }) : console.log(input)}
        </Form.Item>
        {input.comment ?
          <Form.Item
            shouldUpdate={(prevValue, newValue) => prevValue[`${inputData.name}Comment`] !== newValue[`${inputData.name}Comment`]}
            className="comment-textarea"
            name={`${inputData.name}Comment`}
            initialValue={inputData.commentValue}
            hidden={!isShown}
          >
            {inputTypeComponent.comment(inputData, {
              form: MainForm,
              forms: options,
              setFormValues: setValues,
            })}
          </Form.Item>
          : null}
      </>
  }
}
